import React, { useEffect, useState, useRef } from 'react';
import countryList from 'react-select-country-list';
import * as Yup from 'yup';
import './SignUp.css';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonIcon from '@mui/icons-material/Person';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LockIcon from '@mui/icons-material/Lock';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import Recaptcha from 'react-google-invisible-recaptcha';
import { env } from '../../components/app/features/env';
import {
   Box,
   Button,
   TextField,
   Typography,
   IconButton,
   InputAdornment,
   styled,
   CircularProgress,
   Select,
   InputLabel,
   MenuItem,
   FormControlLabel,
   Checkbox,

} from '@mui/material';
import {
   createAccount,
   resetLoading,
} from '../../components/app/features/auth/AuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthSelector } from '../../components/utils/selectors/selectors';
// import GoogleIco../../components/modal/SimpleModalcons.svg';
// import NigeriaFlag from '../../assets/NigeriaFlag.svg';
// import { toast } from 'react-toastify';


const TextInput = styled(TextField)(
   ({ theme }) => `
     color: #49454F;
   `
);

// const SuspendButton = styled(Button)(
//    ({ theme }) => `
//   border-radius: 10px;
//   padding: 2px 5px;
//   font-size: 0.8125rem;
//   background: transparent;
//   border: 1px solid #374DA0;
//   color: #374DA0;
//   width: 45%;
//   margin: 0 auto;
//   margin-top: 15px;
//   whitespace: nowrap;

//   &:hover {
//   background: #F7F7F8;
//   }
//   `
// );

const inputStyle = { WebkitBoxShadow: '0 0 0 1000px white inset' };

const SignUp = () => {
   const dispatch = useDispatch();
   const selector = useSelector(getAuthSelector);
   const [showPassword, setShowPassword] = useState(false);
   const [showPasswordTwo, setShowPasswordTwo] = useState(false);
   const recaptchaRef = useRef(null);
   const countries = countryList().getData();

   const navigate = useNavigate();

   useEffect(() => {
      // redirect user to account-verification page if registration was successful
      dispatch(resetLoading());
      if (selector.loading === 'success') {
         navigate('/account-verification');
      }
   }, [selector.loading]);

   useEffect(() => {
      // redirect user to account-verification page if registration was successful
      dispatch(resetLoading());
      if (selector.error === 400) {
         navigate(selector.action);
      }
   }, [selector.error]);

   const handleClickShowPassword = () => setShowPassword((show) => !show);
   const handleClickShowPasswordTwo = () => setShowPasswordTwo((show) => !show);

   const handleMouseDownPassword = (event) => {
      event.preventDefault();
   };
   const handleCreateAccountSubmit = async (values, { setErrors }) => {

      if (recaptchaRef.current) {
         const recaptChaToken = await recaptchaRef.current.execute();
         if (recaptChaToken) {
            dispatch(createAccount(values));
         } else {
            setErrors({ submit: 'Please complete the reCAPTCHA' });
            recaptchaRef.current.reset();

         }
      }
   };
   const inputStyle = { WebkitBoxShadow: '0 0 0 1000px white inset' };
   <TextField name="last_name" inputProps={{ style: inputStyle }} />;







   return (
      <div>

         <Box
            sx={{ fontSize: { xs: '1.5rem', md: '2.3rem' } }}
            fontWeight={600}
            className="pageHeader font-cormorant"
         >
            Create Account
         </Box>
         <Typography
            sx={{ fontSize: { xs: '0.7rem', md: '1rem' } }}
            fontWeight={400}
            color="#58564d"
            mb={2}
         >
            Just a few quick details and you're in.
         </Typography>
         <Formik
            initialValues={{
               firstName: '',
               lastName: '',
               email: '',
               country: '',
               // phoneNumber: '',
               howDidYouHearAboutUs: '',
               subscribeToNotifications: false,
               password: '',
               confirmPassword: '',
            }}
            validationSchema={Yup.object().shape({
               firstName: Yup.string()
                  .max(255)
                  .required('The name field is required'),
               lastName: Yup.string()
                  .max(255)
                  .required('The name field is required'),
               email: Yup.string()
                  .email('The email provided should be a valid email address')
                  .max(255)
                  .required('The email field is required'),
               country: Yup.string()
                  .required('Please select your country'),
               // phoneNumber: Yup.string()
               // 	.max(255),
               password: Yup.string()
                  .max(255)
                  .required('Please enter your password'),
               confirmPassword: Yup.string()
                  .label('confirm password')
                  .required('Please confirm your password')
                  .oneOf([Yup.ref('password'), null], 'Passwords must match'),
            })}
            onSubmit={handleCreateAccountSubmit}
         >
            {({
               errors,
               handleBlur,
               handleChange,
               handleSubmit,
               isSubmitting,
               touched,
               values,
               setFieldValue,
            }) => (
               <form noValidate onSubmit={handleSubmit}>
                  <label
                     htmlFor="firstName"
                     style={{
                        textAlign: 'left',
                        display: 'block',
                        lineHeight: 1.5,
                        color: '#2E2C21'
                     }}
                  >
                     Name
                  </label>
                  <Box display="" gap={1} sx={{ marginBottom: '1rem' }}>
                     <TextInput
                        sx={{

                           '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                 borderColor: '#D9D9D9',
                              },
                              '&:hover fieldset': {
                                 borderColor: '#D9D9D9',
                              },
                              '&.Mui-focused fieldset': {
                                 borderColor: '#D9D9D9',
                              },
                           },
                        }}
                        fullWidth
                        margin="normal"
                        name="firstName"
                        id="firstName"
                        placeholder="Firstname"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="text"
                        value={values.firstName}
                        variant="outlined"
                        InputProps={{
                           style: inputStyle,

                           endAdornment: values.firstName !== '' && (
                              <InputAdornment position="end">
                                 <IconButton
                                    edge="end"
                                    onClick={() => {
                                       setFieldValue('firstName', '');
                                    }}
                                 >
                                    <HighlightOffIcon />
                                 </IconButton>
                              </InputAdornment>
                           ),
                        }}
                     />
                     <TextInput
                        sx={{
                           marginTop: 2,
                           '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                 borderColor: '#D9D9D9',
                              },
                              '&:hover fieldset': {
                                 borderColor: '#D9D9D9',
                              },
                              '&.Mui-focused fieldset': {
                                 borderColor: '#D9D9D9',
                              },
                           },
                        }}
                        fullWidth
                        margin="normal"
                        name="lastName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="text"
                        value={values.lastName}
                        placeholder="Lastname"
                        variant="outlined"

                        InputProps={{

                           endAdornment: values.lastName !== '' && (
                              <InputAdornment position="end">
                                 <IconButton
                                    edge="end"
                                    onClick={() => {
                                       setFieldValue('lastName', '');
                                    }}
                                 >
                                    <HighlightOffIcon />
                                 </IconButton>
                              </InputAdornment>
                           ),
                        }}
                     />
                  </Box>
                  {/* <TextInput
							fullWidth
							margin='normal'
							name='phoneNumber'
							placeholder='Phone number'
							onBlur={handleBlur}
							onChange={handleChange}
							type='text'
							value={values.phoneNumber}
							variant='outlined'
							InputProps={{
								startAdornment: (
									<InputAdornment position='start'>
										<PhoneIcon />
									</InputAdornment>
								),
								endAdornment: values.phoneNumber !== '' && (
									<InputAdornment position='end'>
										<IconButton
											edge='end'
											onClick={() => {
												setFieldValue('phoneNumber', '');
											}}>
											<HighlightOffIcon />
										</IconButton>
									</InputAdornment>
								),
							}}
						/> */}
                  <label
                     htmlFor="email"
                     style={{
                        textAlign: 'left',
                        display: 'block',
                        lineHeight: 1.5,
                        color: '#2E2C21',

                     }}
                  >
                     Email address
                  </label>
                  <TextInput
                     sx={{

                        '& .MuiOutlinedInput-root': {
                           '& fieldset': {
                              borderColor: '#D9D9D9',
                           },
                           '&:hover fieldset': {
                              borderColor: '#D9D9D9',
                           },
                           '&.Mui-focused fieldset': {
                              borderColor: '#D9D9D9',
                           },
                        },
                     }}
                     fullWidth
                     margin="normal"
                     name="email"
                     id="email"
                     placeholder="Enter email address"
                     onBlur={handleBlur}
                     onChange={handleChange}
                     type="text"
                     value={values.email}
                     variant="outlined"
                     InputProps={{
                        style: {
                           marginBottom: '1rem',
                        },

                        endAdornment: values.email !== '' && (
                           <InputAdornment position="end">
                              <IconButton
                                 edge="end"
                                 onClick={() => {
                                    setFieldValue('email', '');
                                 }}
                              >
                                 <HighlightOffIcon />
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                  />
                  <label
                     htmlFor="password"
                     style={{
                        textAlign: 'left',
                        display: 'block',
                        lineHeight: 1.5,
                     }}
                  >
                     Password
                  </label>
                  <TextInput
                     sx={{
                        '& .MuiOutlinedInput-root': {
                           '& fieldset': {
                              borderColor: '#D9D9D9',
                           },
                           '&:hover fieldset': {
                              borderColor: '#D9D9D9',
                           },
                           '&.Mui-focused fieldset': {
                              borderColor: '#D9D9D9',
                           },
                        },
                     }}
                     error={Boolean(touched.password && errors.password)}
                     fullWidth
                     margin="normal"
                     helperText={touched.password && errors.password}
                     name="password"
                     id="password"
                     placeholder="Enter password"
                     onBlur={handleBlur}
                     onChange={handleChange}
                     type={showPassword ? 'text' : 'password'}
                     value={values.password}
                     variant="outlined"
                     InputProps={{
                        style: {
                           marginBottom: '1rem',
                        },
                       
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowPassword}
                                 onMouseDown={handleMouseDownPassword}
                                 edge="end"
                              >
                                 {showPassword ? (
                                    <VisibilityOff />
                                 ) : (
                                    <Visibility />
                                 )}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                  />
                  <label
                     htmlFor="confirmPassword"
                     style={{
                        textAlign: 'left',
                        display: 'block',
                        lineHeight: 1.5,
                     }}
                  >
                     Confirm password
                  </label>
                  <TextInput
                     sx={{
                        '& .MuiOutlinedInput-root': {
                           '& fieldset': {
                              borderColor: '#D9D9D9',
                           },
                           '&:hover fieldset': {
                              borderColor: '#D9D9D9',
                           },
                           '&.Mui-focused fieldset': {
                              borderColor: '#D9D9D9',
                           },
                        },
                     }}
                     fullWidth
                     margin="normal"
                     helperText={
                        touched.confirmPassword && errors.confirmPassword
                     }
                     error={Boolean(
                        touched.confirmPassword && errors.confirmPassword
                     )}
                     name="confirmPassword"
                     id="confirmPassword"
                     placeholder="Confirm password"
                     onBlur={handleBlur}
                     onChange={handleChange}
                     type={showPasswordTwo ? 'text' : 'password'}
                     value={values.confirmPassword}
                     variant="outlined"
                     InputProps={{
                        style: {
                           marginBottom: '1rem',
                        },
                       
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={handleClickShowPasswordTwo}
                                 onMouseDown={handleMouseDownPassword}
                                 edge="end"
                              >
                                 {showPasswordTwo ? (
                                    <VisibilityOff />
                                 ) : (
                                    <Visibility />
                                 )}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                  />


                  {/* Country and How did you hear about us section */}
                  <Box
                     display="flex"
                     flexDirection={{ xs: 'column', lg: 'column' }}
                     gap={1}
                    
                  >
                     {/* Country Select */}
                     <Box flex={1}>
                        <label
                           htmlFor="country"
                           style={{
                              textAlign: 'left',
                              display: 'block',
                              lineHeight: 1.5,

                           }}
                        >
                           Country
                        </label>
                        <Select

                           displayEmpty
                           value={values.country}
                           onChange={(event) => {

                              const selectedCountry = countries.find(country => country.value === event.target.value);

                              setFieldValue('country', selectedCountry ? selectedCountry.label : event.target.value);
                           }}
                           onBlur={handleBlur}
                           fullWidth
                           name="country"
                           id="country"
                           error={Boolean(touched.country && errors.country)}
                           sx={{
                              '& .MuiOutlinedInput-root': {
                                 '& fieldset': {
                                    borderColor: '#D9D9D9',
                                 },
                                 '&:hover fieldset': {
                                    borderColor: '#D9D9D9',
                                 },
                                 '&.Mui-focused fieldset': {
                                    borderColor: '#D9D9D9',
                                 },
                              },
                              textAlign: 'left',
                              marginTop: '10px',
                           }}
                           renderValue={(selected) => {
                              if (!selected) {
                                 return (
                                    <span style={{ color: '#aaa', textAlign: 'left' }}>
                                       Select your country
                                    </span>
                                 );
                              }

                              return selected;
                           }}
                        >
                           {countries.map((country) => (
                              <MenuItem key={country.value} value={country.value}>
                                 {country.label}
                              </MenuItem>
                           ))}
                        </Select>
                        {touched.country && errors.country && (
                           <Typography color="error" variant="caption" sx={{ mt: 0.5, display: 'block' }}>
                              {errors.country}
                           </Typography>
                        )}
                     </Box>

                     {/* How did you hear about us Select */}
                     <Box flex={1}>
                        <label
                           htmlFor="howDidYouHearAboutUs"
                           style={{
                              textAlign: 'left',
                              display: 'block',
                              lineHeight: 1.5,
                              color:'#58564d',
                        

                           }}
                           
                        >
                           How did you hear about us?
                        </label>
                        <Select
                           displayEmpty
                           value={values.howDidYouHearAboutUs}
                           onChange={handleChange}
                           fullWidth
                           name="howDidYouHearAboutUs"
                           sx={{
                              textAlign: 'left',
                              marginTop: '10px',
                           }}
                           renderValue={(selected) => {
                              if (!selected) {
                                 return (
                                    <span style={{ color: '#aaa', textAlign: 'left' }}>
                                       Select source
                                    </span>
                                 );
                              }
                              return selected;
                           }}
                        >
                           <MenuItem value="LinkedIn">LinkedIn</MenuItem>
                           <MenuItem value="X">X</MenuItem>
                           <MenuItem value="Facebook">Facebook</MenuItem>
                           <MenuItem value="Instagram">Instagram</MenuItem>
                           <MenuItem value="YouTube">YouTube</MenuItem>
                           <MenuItem value="Tiktok">Tiktok</MenuItem>
                           <MenuItem value="Google">Google</MenuItem>
                           <MenuItem value="Referral">Referral</MenuItem>
                        </Select>
                     </Box>
                  </Box>





                  <FormControlLabel
                     control={
                        <Checkbox
                           name="subscribeToNotifications"
                           checked={values.subscribeToNotifications}
                           onChange={handleChange}

                           color="primary"
                        />
                     }
                     label="Would you like to receive notifications and newsletters from us?"
                     style={{ width: '100%', margin: '0.2rem 0', color:'#58564d',fontSize:'0.9rem',fontWeight:400 }}
                  />






                  <Typography
                     fontSize={13}
                    style={{ textAlign: 'start', marginTop: '10px',fontSize:'0.9rem' }}
                     fontWeight={400}
                     color="#58564d"
                  >
                     By clicking next, you agree to Parrotica's
                     <a
                        href="https://parrotica.com/policy.html"
                        className="termsLink"
                        style={{color:'#0040bf'}}
                     >
                        {' '}
                        Privacy Policy{' '}
                     </a>{' '}
                     and{' '}
                     <a
                        href="https://parrotica.com/terms.html"
                        className="termsLink"
                        style={{color:'#0040bf'}}
                     >
                        {' '}
                        Legal Term of Use
                     </a>
                  </Typography>
                  <Button
                     sx={{
                        borderRadius: '11px',
                        py: '10px',
                        px: '35px',
                        fontSize: '1rem',
                        width: '100%',
                        mx: 'auto',
                        my: '0.5rem',
                        background:'#0040BF'
                     }}
                     variant="contained"
                     size="small"
                     type="submit"
                     startIcon={
                        selector.loading === 'pending' ? (
                           <CircularProgress size="1rem" color="primary" />
                        ) : null
                     }
                     disabled={
                        !values.firstName ||
                        !values.lastName ||
                        !values.email ||
                        !values.country ||
                        !values.password ||
                        !values.confirmPassword
                     }
                  >
                     Next
                  </Button>
                  <Typography>
                     Already have an account?{' '}
                     <Link to="/login" className="termsLink">
                        Log in
                     </Link>
                  </Typography>
                  <Recaptcha
                     ref={recaptchaRef}
                     sitekey={env.REACT_APP_RECAPTCHA_SITE_KEY}
                  />
               </form>
            )}
         </Formik>
      </div>
   );
};

export default SignUp;
